import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { guestGuard } from './core/guards/guest.guard';
import { ADMIN_SHELL_CHILDREN } from './features/admin/admin-child.routes';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./features/landing/pages/home/home-page').then((m) => m.HomePage),
  },
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./features/auth/pages/login-page/login-page.component').then((m) => m.LoginPageComponent),
  },
  {
    path: 'auth/entra-callback',
    loadComponent: () =>
      import('./features/auth/pages/entra-callback-page/entra-callback-page.component').then(
        (m) => m.EntraCallbackPageComponent,
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/auth/pages/forgot-password-page/forgot-password-page.component').then(
        (m) => m.ForgotPasswordPageComponent,
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./features/auth/pages/reset-password-page/reset-password-page.component').then(
        (m) => m.ResetPasswordPageComponent,
      ),
  },
  {
    path: 'accept-invitation',
    loadComponent: () =>
      import('./features/auth/pages/set-new-password-page/set-new-password-page.component').then(
        (m) => m.SetNewPasswordPageComponent,
      ),
  },
  {
    // Alias so links sent before the invitation flow (SP2c-1) still open the same page.
    path: 'set-new-password',
    loadComponent: () =>
      import('./features/auth/pages/set-new-password-page/set-new-password-page.component').then(
        (m) => m.SetNewPasswordPageComponent,
      ),
  },
  {
    path: 'activate-account',
    loadComponent: () =>
      import('./features/auth/pages/activate-account-page/activate-account-page.component').then(
        (m) => m.ActivateAccountPageComponent,
      ),
  },
  {
    path: 'terms-and-conditions',
    data: { slug: 'terms-and-conditions' },
    loadComponent: () =>
      import('./features/landing/pages/public-content/public-content-page').then((m) => m.PublicContentPage),
  },
  {
    path: 'privacy-policy',
    data: { slug: 'privacy-policy' },
    loadComponent: () =>
      import('./features/landing/pages/public-content/public-content-page').then((m) => m.PublicContentPage),
  },
  {
    path: 'refund-policy',
    data: { slug: 'refund-policy' },
    loadComponent: () =>
      import('./features/landing/pages/public-content/public-content-page').then((m) => m.PublicContentPage),
  },
  {
    path: 'delivery-policy',
    data: { slug: 'delivery-policy' },
    loadComponent: () =>
      import('./features/landing/pages/public-content/public-content-page').then((m) => m.PublicContentPage),
  },
  {
    path: 'contact-us',
    data: { slug: 'contact-us' },
    loadComponent: () =>
      import('./features/landing/pages/public-content/public-content-page').then((m) => m.PublicContentPage),
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./features/auth/pages/unauthorized-page/unauthorized-page.component').then((m) => m.UnauthorizedPageComponent),
  },
  {
    // AI Agents SP1d (contracts §2, A9): the OAuth consent step, outside the admin shell. authGuard sends a signed-out
    // visitor to /login?returnUrl=…; password, tenant pick and Entra (returnUrl in sessionStorage) all come back here.
    // Declared before the shell so the shell's `ai-agents` area never claims this path (ruling D1).
    path: 'ai-agents/consent',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/auth/pages/ai-agent-consent-page/ai-agent-consent-page.component').then(
        (m) => m.AiAgentConsentPageComponent,
      ),
  },
  {
    path: '',
    canActivate: [authGuard, permissionGuard],
    loadComponent: () => import('./features/admin/shell/admin-shell.component').then((m) => m.AdminShellComponent),
    children: ADMIN_SHELL_CHILDREN,
  },
  { path: '**', redirectTo: '' },
];
